import { type FC, forwardRef, type ChangeEvent } from 'react';
import { optionalProp } from '../core';
import { MLPVersion } from '../types/enums';
import FloatLabelInput from './FloatLabelInput/FloatLabelInput';
import ClassicInput from './ClassicInput/ClassicInput';
import {
  type InputFieldPropsTypes,
  type FloatLabelInputFieldPropType,
  VALUE_MAX_LENGTH,
  type InputTheme,
} from './types/propsType';
import { InputValidations, InputTypes, InputAutoComplete, InputModes } from './types/enums';
import './Input.scss';

const Input: FC<InputFieldPropsTypes | FloatLabelInputFieldPropType> = forwardRef<
  HTMLInputElement,
  InputFieldPropsTypes | FloatLabelInputFieldPropType
>(({ mlpVersion = MLPVersion.TWO, prefix, ...restProps }: InputFieldPropsTypes | FloatLabelInputFieldPropType, ref) => {
  const configs = ConfigService.getConfigs();
  const enableAsterisk = configs?.SHOW_ASTERISK_FOR_MANDATORY_FIELDS as boolean;
  const onInput = (_e: ChangeEvent<HTMLInputElement>) => {
    const { value, maxLength } = _e.target;
    _e.target.value = value.length > maxLength && maxLength > 0 ? value.slice(0, maxLength) : value;
  };

  const tempOnChange = restProps.onChange;
  function privateOnChange(event: ChangeEvent<HTMLInputElement>) {
    const { type } = restProps;
    if (type === InputTypes.NUMBER) {
      const regex = /^(\d+)?(\d+\.\d*)?$/gm;
      const res = regex.test(event.target.value);
      if (!res) {
        event.target.value = restProps.value as string;
      }
    }
    tempOnChange?.(event);
  }
  restProps.onChange = privateOnChange;
  if (mlpVersion === MLPVersion.TWO && prefix) {
    restProps.maxLength = restProps?.maxLength ?? VALUE_MAX_LENGTH; // value length should not exceeds length 20 as per design
  }
  const WrapperInput = mlpVersion === MLPVersion.ONE ? ClassicInput : FloatLabelInput;

  return (
    <WrapperInput
      onInput={onInput}
      {...restProps}
      forwardedRef={ref}
      {...optionalProp('prefix', prefix)}
      showAsteriskForMandatoryField={enableAsterisk ?? false}
    />
  );
});
Input.displayName = 'Input';
export { InputValidations, InputTypes, InputAutoComplete, MLPVersion, InputModes };
export default Input;
export type { InputTheme };
